import { FormControl, FormGroup, FormLabel } from '@mui/material';
import { Control } from 'react-hook-form';

import { CheckboxInput } from '@attackiq/components';

interface ShowInAppFormGroupProps {
  control?: Control;
}

export const ShowInAppFormGroup = ({ control }: ShowInAppFormGroupProps) => {
  return (
    <FormControl component="fieldset" variant="standard">
      <FormLabel component="legend">Show In</FormLabel>
      <FormGroup>
        <CheckboxInput control={control} name="show_in_enterprise" label="Enterprise" />
        <CheckboxInput control={control} name="show_in_ready" label="Ready!" />
        <CheckboxInput control={control} name="show_in_flex" label="Flex" />
      </FormGroup>
      {/* <FormHelperText>Apps</FormHelperText> */}
    </FormControl>
  );
};
